<template>
	<div id="teams" class="teams">
		<div v-if="activeTeams == '0'">
			<nav class="navbar navbar-light bg-light">
				<div class="form-inline">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromTeams" @change="getAllTeamsLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToTeams" @change="getAllTeamsLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchTeams"
						v-model="searchTeams"
						v-on:keyup.enter="getAllTeamsLocal(1)"
						@focus="$event.target.select()">
					<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllTeamsLocal(1)">Buscar</button>
					<div class="float-right d-none d-sm-inline separator"></div>
					<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nueva Campaña" @click="showTeamModalComponentLocal(0)">
						<i class="fas fa-plus"></i>
					</button>
				</div>
				<div class="form-inline">
					<span @click="setActiveTeams('1')" class="pointer">Solo Abiertas</span>
					<div class="float-right d-none d-sm-inline separator"></div>
					<span class="mr-sm-1">Mostrar</span>
					<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsTeam" @change="changeQRowsTeam">
						<option>5</option>
						<option>10</option>
						<option>25</option>
						<option>50</option>
						<option>100</option>
						<option>200</option>
						<option>1000</option>
					</select>
				</div>
			</nav>
			<div>
				<table class="table table-sm table-hover table-12">
					<thead>
						<tr>
							<th class="text-center">ID</th>
							<th class="text-center">Nombre</th>
							<th class="text-center">Asistente</th>
							<th class="text-center">Campo</th>
							<th class="text-center">Fecha de Inicio</th>
							<th class="text-center">Fecha de Cierre</th>
							<th class="text-center">Estado</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in listTeams" :key="index" :class="(item.status_id == 42) ? 'text-dark' : 'text-secondary'">
							<td class="text-center">{{ item.id }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.client.name + ' ' + item.client.surname }}</td>
							<td class="text-center">{{ item.entity.name }}</td>
							<td class="text-center">{{ item.begin_date }}</td>
							<td class="text-center">{{ item.end_date }}</td>
							<td class="text-center">
								{{ (item.status === null) ? '-' : item.status.name }}
							</td>
							<td>
								<router-link :to="'/team/' + item.id" class="pointer far fa-eye text-info" :title="'Campaña' + item.name"></router-link>
							</td>
						</tr>
					</tbody>{{listTeams.length}}
				</table>
				<pagination :pagination="paginationTeams" @getAllList="getAllTeamsLocal" ></pagination>
			</div>
		</div>

		<div v-else>
			<div class="row">
				<router-link v-for="(item, index) in listTeams" :key="index" :to="'team/' + item.id" :title="'Campaña' + item.name" class="col-12" :class="'col-lg-' + col">
					<!-- small box -->
					<div class="small-box" :class="'bg-' + item.entity.synthetic">
						<div class="inner pointer text-white">
							<h3 style="font-weight: normal;">5.000.500
								<small class="float-right">{{item.id}}</small>
							</h3>
							<p class="text-white">
								{{ item.name }}
							</p>
						</div>
						<div class="inner text-light">
							{{ item.client.name + ' ' + item.client.surname }}
							<span class="float-right">{{item.entity.synthetic}}</span>
						</div>
						<div class="icon">
							<i class="ion ion-bag"></i>
						</div>
					</div>
				</router-link>
				<div class="col-lg-2 col-12">
				<!-- small box -->
					<div class="small-box bg-primary" title="Nueva Campaña" @click="showTeamModalComponentLocal(0)">
						<div class="inner pointer text-white">
							<h3 style="font-weight: normal;">Nuevo</h3>
							<p class="text-white">Agregar Otra Campaña</p>
						</div>
						<div class="inner text-light">
							
						</div>
						<div class="icon">
							<i class="ion ion-plus"></i>
						</div>
					</div>
				</div>
			</div>
			<span @click="setActiveTeams('0')" class="pointer float-right">Mostrar Todo</span>
		</div>
		<team-modal-component ref="teamModalComponent" :id="id" @saveTeam="saveTeamLocal"></team-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import team from '@/mixins/teams'

import Pagination from '@/components/Pagination.vue'
import TeamModalComponent from '@/components/TeamModalComponent.vue'

export default {
	name: 'Teams',
	mixins: [axiosAction, errors, mixin, team],
	data() {
		return {
			id: 0,
			activeTeams: 1,
			col: 3
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Campañas')
			this.setSubTitleModule('')
			this.activeTeams = (localStorage.getItem('activeTeams') === null) ? this.activeTeams : localStorage.getItem('activeTeams')
			this.setTeamInit()
		},
		changeQRowsTeamLocal() {
			this.getAllTeamsLocal(1)
		},
		getAllTeamsLocal(page = 1) {
			let statusId = (this.activeTeams == '1') ? 42 : -1
			this.getAllTeamByUserClient(page, statusId)
		},
		getAllTeamsResultLocal(response) { },
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllTeamsResult': this.getAllTeamsResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveTeamLocal(data) {
			if(data.message == 'NEW') {
				this.addListTeams(data.data)
			} else if(data.message == 'UDPATE') {
				this.updateListTeam(data.data)
			}
		},
		setActiveTeams(value) {
			this.activeTeams = value
			localStorage.setItem('activeTeams', this.activeTeams)
			this.getAllTeamsLocal(1)
		},
		setTeamInitLocal() {
			this.getAllTeamsLocal(1)
		},
		showTeamModalComponentLocal(id) {
			this.id = id
			this.$refs.teamModalComponent.$refs.btnShowTeamModalComponent.click()
		}
	},
	components: {
        'pagination': Pagination,
		'team-modal-component': TeamModalComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>